import { UserManager } from 'oidc-client';
import { useContext, useEffect } from 'react';
import { ConfigContext } from '../config/ConfigContext';
import { RouteComponentProps } from '../helpers/RouteComponentProps';
import { getUserManagerSettings } from './userManagerSettings';

type AuthenticationTokenSilentRefreshComponent = {
  (props: RouteComponentProps): JSX.Element | null;
};

export const AuthenticationTokenSilentRefresh: AuthenticationTokenSilentRefreshComponent = () => {
  const config = useContext(ConfigContext);
  const azureActiveDirectoryConfig = config.getConfig().azureActiveDirectory;

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('Handling silent token refresh callback');
    const userManager = new UserManager(getUserManagerSettings({ azureActiveDirectoryConfig }));
    void userManager.signinSilentCallback();
  });

  return null;
};
